<template>
  <div class="bg-white rounded-lg border border-gray-200 p-4 w-full animate-pulse">
    <div class="h-6 bg-gray-200 rounded w-1/3 mb-2"></div>
    <div class="h-4 bg-gray-200 rounded w-1/2"></div>
  </div>
</template>